import DecorativeAnimation from '../lib/decorative-animation.js';

class ThemeScreensaver {
	constructor(dom) {
		this.dom = dom;
		this.animationDom = dom.querySelector('[data-theme-screensaver-animation]');
		this.animationDelay = 1000 * 60 * 5;
		this.activityEvents = ['pointermove', 'pointerdown', 'keydown', 'touchstart', 'wheel'];
	}

	init() {
		if (!this.animationDom) return;
		this.animation = new DecorativeAnimation(this.animationDom);
		this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
		this.onActivity = () => this.resetTimer();
		this.onPageHide = () => this.stop();
		this.onUnload = event => {
			if (event.target.contains(this.dom)) this.destroy();
		};
		this.activityEvents.forEach(name => document.addEventListener(name, this.onActivity, { passive: true }));
		document.addEventListener('visibilitychange', this.onActivity);
		document.addEventListener('shopify:section:unload', this.onUnload);
		this.motion.addEventListener('change', this.onActivity);
		window.addEventListener('pagehide', this.onPageHide);
		window.addEventListener('pageshow', this.onActivity);
		this.resetTimer();
	}

	stop() {
		clearTimeout(this.animationTimer);
		this.animation.destroy();
	}

	resetTimer() {
		this.stop();
		if (document.hidden || this.motion.matches || !this.dom.isConnected) return;
		this.animationTimer = setTimeout(() => {
			if (!document.hidden && !this.motion.matches && this.dom.isConnected) void this.animation.play();
		}, this.animationDelay);
	}

	destroy() {
		this.stop();
		this.activityEvents.forEach(name => document.removeEventListener(name, this.onActivity));
		document.removeEventListener('visibilitychange', this.onActivity);
		document.removeEventListener('shopify:section:unload', this.onUnload);
		this.motion.removeEventListener('change', this.onActivity);
		window.removeEventListener('pagehide', this.onPageHide);
		window.removeEventListener('pageshow', this.onActivity);
	}
}

export default ThemeScreensaver;
